import loadable from '@loadable/component';

export const OrgDashboardIntegrationPartnerClientsLoadable = loadable(
  () => import('./OrgDashboardIntegrationPartnerClients'),
  {
    resolveComponent: (module) => module.OrgDashboardIntegrationPartnerClients,
  },
);
